import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class WalletPassService {

  private loginUrl = `${environment.apiUrl}/mobileWallet-receipt`;

  constructor(private http: HttpClient) {}

  openPass(passId: string, params: { idType: any; alter: any; os?: string }) {
    window.location.href = this.buildPassUrl(passId, params);
  }

  downloadPass(passId: string, params: { idType: any; alter: any; os?: string }) {
    return this.http.get(
      this.buildPassUrl(passId, params),
      { responseType: 'blob' }
    );
  }

  private buildPassUrl(passId: string, params: { idType: any; alter: any; os?: string }): string {
    const os = params.os || 'ios';
    return `${this.loginUrl}/${passId}/${params.idType}/${params.alter}/${os}`;
  }

  handoffPassBlob(blob: Blob): void {
    const passBlob = new Blob([blob], { type: 'application/vnd.apple.pkpass' });
    const url = window.URL.createObjectURL(passBlob);
    window.location.assign(url);
    setTimeout(() => window.URL.revokeObjectURL(url), 10000);
  }
}
